import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ss1 from "../assets/ss1.png";
import ss2 from "../assets/ss2.png";
import ss3 from "../assets/ss3.png";
import ss4 from "../assets/ss4.png";
import ss6 from "../assets/ss6.png";
import ss7 from "../assets/ss7.png";
import ss8 from "../assets/ss8.png";
import ss9 from "../assets/ss9.png";
import ss10 from "../assets/ss10.png";
import introVideo from "../assets/intro-video.mp4";

const GallerySection = styled.section`
  padding: 80px 0;
  background-color: #f9f9f9;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #1a5f7a;
  margin-bottom: 20px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  max-width: 700px;
  margin: 0 auto 50px;
  color: #666;
`;

const StyledSlider = styled(Slider)`
  .slick-slide {
    padding: 10px;
  }

  .slick-prev,
  .slick-next {
    z-index: 1;
    width: 40px;
    height: 40px;

    &:before {
      font-size: 40px;
      color: #1a5f7a;
    }
  }

  .slick-prev {
    left: -20px;
  }

  .slick-next {
    right: -20px;
  }

  .slick-dots {
    bottom: -40px;

    li button:before {
      color: #1a5f7a;
    }

    li.slick-active button:before {
      color: #1a5f7a;
    }
  }
`;

const ImageContainer = styled.div`
  position: relative;
  padding-top: 75%; /* 4:3 Aspect Ratio */
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

const GalleryImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const VideoContainer = styled.div`
  margin: 40px auto;
  max-width: 800px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const Video = styled.video`
  width: 100%;
  display: block;
`;

const Gallery = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const images = [ss1, ss2, ss3, ss4, ss6, ss7, ss8, ss9, ss10];

  return (
    <GallerySection>
      <Container>
        <SectionTitle>Gallery</SectionTitle>
        <SectionSubtitle>
          Take a closer look at our beautiful apartments and amenities
        </SectionSubtitle>

        <VideoContainer>
          <Video controls>
            <source src={introVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </Video>
        </VideoContainer>

        <StyledSlider {...settings}>
          {images.map((image, index) => (
            <ImageContainer key={index}>
              <GalleryImage src={image} alt={`Gallery image ${index + 1}`} />
            </ImageContainer>
          ))}
        </StyledSlider>
      </Container>
    </GallerySection>
  );
};

export default Gallery;
